/**
 * Robinetterie de douche
 */
import CustomObject from '../CustomObject.js'

export default class ShowerFaucet extends CustomObject
{
    constructor(modelPath, position, id, rotation, subType) {
        super(modelPath, position, id, rotation, subType);
        this.type = "showerFaucet";
        this.collisionAllowed = true;
        this.snappingAllowed = true;
        this.subType = subType;
        this.axesMove = [true, false, true]; // x, y
    }
}